import Ajax from '../../global/od/Ajax';

export default class deliveryDateChange {
	constructor() {
		this.selectfield = $('#selectDeliveryDate');
		// Get language code from window.od object and append to request path
		let languageCode = '/';
		if (window.od && window.od.config && window.od.config.language) {
			languageCode = `/${window.od.config.language.substring(0, 2)}`;
			languageCode.toLowerCase();
		}
		this.url = `${languageCode}/checkout/multi/review/selectedDeliveryDate/save`;

		if (this.selectfield) {
			this.selectfield.on('change', () => {
				this.submitDeliveryDate();
			});
		}
	}

	submitDeliveryDate() {
		const selectedDateValue = this.selectfield.val();
		const postData = {
			deliveryDate: selectedDateValue,
		};

		Ajax.post(this.url, postData)
			.then(() => {})
			.catch(() => {});
	}
}
